import styled from 'styled-components';
import {
  MenuList,
  MenuListItem,
} from '@pearsontechnology/aero-components';

export const WorkspaceList = styled(MenuList)`
  padding: 20px 30px 140px;
  height: 339px;
  overflow: -moz-scrollbars-none;
  overflow: hidden;
  overflow-y: auto;
`;

export const WorkspaceListItem = styled(MenuListItem)`
  display: flex;
  height: auto;
  min-height: min-content;
  font-size: 14px;
  line-height: 18px;
  padding-top: 5px;
  padding-bottom: 5px;

  &:focus {
    box-shadow: none;
  }

  & svg {
    margin-right: 15px;
  }
`;
